module.exports = __webpack_public_path__ + "img/ic-docs.f79a1487.svg";